export default () => {
  return {
    content: {
      client_physician_id: null,
      panels: [],
      shipping_method: 'standard',
    },
  };
};
